import { Card, CardContent, Typography, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
  border: '1px solid #E5E7EB',
  borderRadius: '12px',
  boxShadow: 'none',
  marginBottom: theme.spacing(3),
  backgroundColor: '#FFFFFF'
}));

interface CampaignDetailsSectionProps {
  campaignName: string;
  onCampaignNameChange: (name: string) => void;
}

const CampaignDetailsSection = ({
  campaignName,
  onCampaignNameChange
}: CampaignDetailsSectionProps) => {
  return (
    <StyledCard>
      <CardContent sx={{ p: 4 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: '1.25rem',
            letterSpacing: '-0.015em',
            mb: 0.5,
            color: '#111827',
            fontFamily: '"Inter", sans-serif'
          }}
        >
          Campaign Details
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mb: 3,
            color: '#6B7280',
            fontSize: '0.875rem',
            fontFamily: '"Inter", sans-serif'
          }}
        >
          Give your campaign a name to identify it later.
        </Typography>
        
        <TextField
          fullWidth
          label="Campaign Name"
          placeholder="e.g., Q3 Customer Feedback"
          value={campaignName}
          onChange={(e) => onCampaignNameChange(e.target.value)}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: 56,
              borderRadius: '8px',
              backgroundColor: '#F9FAFB',
              '& fieldset': {
                borderColor: '#D1D5DB'
              },
              '&:hover': {
                backgroundColor: '#F3F4F6',
                '& fieldset': {
                  borderColor: '#9CA3AF'
                }
              },
              '&.Mui-focused': {
                backgroundColor: 'white',
                '& fieldset': {
                  borderColor: '#4F46E5'
                }
              }
            }
          }}
        />
      </CardContent>
    </StyledCard>
  );
};

export default CampaignDetailsSection;

